import { Box } from "@mui/material";

export const PageWrapper: React.FC<{ children: React.ReactNode; backgroundImage?: string }> = ({ children, backgroundImage }) => {
    return (
        <Box
            sx={{
                position: 'relative',
                px: 2,
                py: 1,
            }}
        >
            {backgroundImage && (
                <img
                    src={backgroundImage}
                    alt="background"
                    style={{ width: '100%',objectFit:'contain', minHeight: "750px", zIndex: -1, position: 'absolute', inset: 0 }} 
                />
            )}
            <Box sx={{ position: 'relative', zIndex: 1 }}>
                {children}
            </Box>
        </Box>
    )
}
